export default "__VITE_ASSET__Akgz4cle__"